import { ChakraStylesConfig } from "chakra-react-select";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL!;
export const SUPABASE_PUBLIC_KEY = process.env.REACT_APP_SUPABASE_PUBLIC_KEY!;
export const DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL;
export const PERSONA_ENV_ID = process.env.REACT_APP_PERSONA_ENV_ID;
export const PERSONA_TEMPLATE_ID = process.env.REACT_APP_PERSONA_TEMPLATE_ID;

export const ADMIN_ROLE = "Administrator";

export const selectChakraStyles: ChakraStylesConfig = {
    menuList: (provided, state) => ({
        ...provided,
        paddingX: "11px",
        position: "absolute",
        maxHeight: "200px",
    }),
    control: (provided, state) => ({
        ...provided,
        borderWidth: "1.5px",
        borderColor: "gray.50",
        padding: "0px",
        borderRadius: "7px",
    }),
    option: (provided, state) => ({
        ...provided,
        background: "white",
        color: "secondary",
        fontSize: "14px",
        fontWeight: "400",
        paddingX: "15px",
        paddingY: "6px",
        _hover: {
            background: "#F9F8F8",
            borderRadius: "5px",
        },
    }),
    multiValue: (provided, state) => ({
        ...provided,
        background: "#ECECEC",
        borderRadius: "16px",
        height: "24px",
        paddingY: "11px",
        paddingX: "12px",
        fontWeight: "500",
    }),
    multiValueRemove: (provided, state) => ({
        ...provided,
        fontSize: "14px",
        marginLeft: "0px",
        color: "#595959",
        fontWeight: "500",
    }),
};

export const AVATAR_URL =
    "https://bbgrbdmdytrbzgdcubpg.supabase.co/storage/v1/object/public/avatars/";

export const DRAW_REQUEST_SECTIONS: string[] = [
    "First Distribution",
    "Second Distribution",
    "Third Distribution",
    "Fourth Distribution",
    "Fifth Distribution",
    "Sixth Distribution",
    "Seventh Distribution",
    "Eighth Distribution",
    "Ninth Distribution",
    "Tenth Distribution",
    "Eleventh Distribution",
    "Twelth Distribution",
    "Thirteenth Distribution",
    "Fourteenth Distribution",
    "Fifthteenth Distribution",
    "Sixteenth Distribution",
    "Seventeenth Distribution",
    "Eighteenth Distribution",
    "Ninteenth Distribution",
    "Twentieth Distribution",
];

export const ACCEPTED_FILE_TYPES = {
    "image/*": [".png", ".jpeg", ".jpg"],
    "application/msword": [], // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        [], // .docx
    "text/csv": [],
    "application/vnd.ms-excel": [], // .xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [], // .xlsx
    "application/pdf": [],
};

export const FIXED_FIELDS = [
    {
        id: "Select",
        label: "Select",
        type: "Select",
        data_key: "Select",
        show: true,
    },
    {
        id: "created_at",
        label: "Date Added",
        type: "date",
        data_key: "created_at",
        show: false,
    },
    {
        id: "name",
        label: "Loan Name",
        type: "name",
        data_key: "name",
        show: true,
    },
    {
        id: "borrower",
        label: "Borrower",
        type: "company",
        data_key: "borrower",
        show: true,
    },
    {
        id: "loan_type",
        label: "Type",
        type: "loan_type",
        data_key: "loan_type",
        show: true,
    },
    {
        id: "status",
        label: "Status",
        type: "status",
        data_key: "status",
        show: true,
    },
];

export const SENIOR_MANAGEMENT_FIXED_FIELDS = [
    {
        id: "Select",
        label: "Select",
        type: "Select",
        data_key: "Select",
        show: true,
    },
    {
        id: "loan_number",
        label: "Loan Number",
        type: "loan_id",
        data_key: "id",
        show: true,
    },
    {
        id: "funding_date",
        label: "Funding Date",
        type: "date",
        data_key: "funding_date",
        show: true,
    },
    {
        id: "name",
        label: "Loan Name",
        type: "name",
        data_key: "name",
        show: true,
    },
    {
        id: "loan_type",
        label: "Loan Type",
        type: "loan_type",
        data_key: "loan_type",
        show: true,
    },
    {
        id: "status",
        label: "Status",
        type: "status",
        data_key: "status",
        show: true,
    },
    {
        id: "amount",
        label: "Loan Amount",
        type: "dollar",
        data_key: "amount",
        show: true,
    },
];

export const Property_types: string[] = ["Mezz debt", "Senior", "Junior"];

export const monthsForStatements: string[] = [
    "1 Month",
    "3 Months",
    "6 Months",
    "12 Months",
];

//For SSN Format
export const dollerValueSSN: string[] = ["$1-$2-$3"];
export const regexSSN: { pattern: RegExp; inputValidation: RegExp } = {
    pattern: /^(\d{3})(\d{2})(\d{4})$/,
    inputValidation: /^\d{0,3}-?\d{0,2}-?\d{0,4}$/,
};
export const placeHolderValueSSN: string[] = ["XXX-XX-XXXX"];

//For EIN Format
export const dollerValueEIN: string[] = ["$1-$2"];
export const regexEIN: { pattern: RegExp; inputValidation: RegExp } = {
    pattern: /^(\d{2})(\d{7})$/,
    inputValidation: /^\d{0,2}-?\d{0,7}$/,
};
export const placeHolderValueEIN: string[] = ["XX-XXXXXXX"];
